import Label from './Label';
export { Sublabel } from './SubLabel';
export * from './Label';
export * from './utils';
export default Label;
